import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { wrapperStyles, titleStyles, verticalCenterStyles, textStyles } from './styles'

const Wrapper = styled('div')(wrapperStyles)
const Title = styled('h2')(titleStyles, verticalCenterStyles)
const Text = styled('h2')(textStyles, verticalCenterStyles)
function CardHeader ({ title, text, extra }) {
  return (
    <Wrapper>
      <header>
        <Title>{title}</Title>
        {text && <Text>{text}</Text>}
      </header>

      {extra}
    </Wrapper>
  )
}

CardHeader.propTypes = {
  title: PropTypes.node.isRequired,
  text: PropTypes.node,
  extra: PropTypes.node
}

CardHeader.defaultProps = {
  text: null,
  extra: null
}

export default CardHeader
